var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyUpDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 20,
    viewBox: "0 0 9 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.15402C0 4.33125 0.0678465 4.50848 0.202847 4.64348C0.473539 4.91417 0.911077 4.91417 1.18177 4.64348L4.15385 1.6714L7.12592 4.64348C7.39662 4.91417 7.83415 4.91417 8.10485 4.64348C8.37554 4.37279 8.37554 3.93525 8.10485 3.66456L4.64331 0.203019C4.37262 -0.0676731 3.93508 -0.0676731 3.66438 0.203019L0.202847 3.66456C0.0678465 3.79956 0 3.97679 0 4.15402Z",
    fill: "#D7D7D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48468e-07 15.2323C3.48468e-07 15.0551 0.0678467 14.8779 0.202847 14.7429C0.473539 14.4722 0.911077 14.4722 1.18177 14.7429L4.15385 17.715L7.12592 14.7429C7.39662 14.4722 7.83415 14.4722 8.10485 14.7429C8.37554 15.0136 8.37554 15.4511 8.10485 15.7218L4.64331 19.1833C4.37262 19.454 3.93508 19.454 3.66438 19.1833L0.202847 15.7218C0.0678467 15.5868 3.48468e-07 15.4096 3.48468e-07 15.2323",
    fill: "#D7D7D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyUpDownArrow);
export default __webpack_public_path__ + "static/media/grey-up-down-arrow.f2b0e20678830d8305d3c24dcfde9129.svg";
export { ForwardRef as ReactComponent };